<template>
  <div class="pt-4 sm:pt-0 pl-2 sm:pl-0 pr-4 sm:pr-1 sm:pb-1 w-full h-full">
    <div
      v-if="plotting.mode === 'transmitter'"
      class="pl-8 pr-3 w-full h-full">
      <h1 class="text-sm text-white font-bold">Form Editor Tracking</h1>
      <div class="py-3">
        <div class="w-full mb-1">
          <label class="text-xs text-white">Transmitter</label>
          <input
            v-model="plotting.transmitter"
            class="w-full h-full rounded-md text-sm text-gray-500"
            type="text"
            placeholder="masukan nomor transmitter kapal">
        </div>
      </div>
      <div class="flex flex-col">
        <div class="flex justify-end items-center">
          <button
            @click="inputTransmitter()"
            class="px-1 py-1 w-28 h-8 bg-green-500 text-white text-xs rounded-md"
            type="button">Lanjut</button>
        </div>
      </div>
    </div>
    <div
      v-else-if="plotting.mode === 'import'"
      class="pl-8 pr-3 w-full h-full">
      <h1 class="text-sm text-white font-bold">Tambah Traffic</h1>
      <div class="py-3">
        <div class="w-full mb-1">
          <label class="text-xs text-white">Import Berkas Tracking <i>(boleh kosong)</i></label>
          <div class="relative flex flex-row items-center w-full h-8 bg-white border border-gray-500 rounded-md">
            <span
              class="grow-1 w-full  z-0 px-3 text-xs text-gray-500"
              style="white-space: nowrap;overflow: hidden;">{{ file ? file.name : 'klik untuk pilih file' }}</span>
            <i class="material-icons flex z-0 justify-center items-center w-8 h-8 text-lg text-gray-500">upload_file</i>
            <input
              @change="selectFile($event)"
              class="absolute top-0 right-0 bottom-0 left-0 z-0 form-input w-full h-8 rounded-md text-xs opacity-0"
              type="file">
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="flex gap-1 justify-end items-center">
          <button
            @click="downloadTemplate()"
            class="px-1 py-1 grow-1 w-full h-8 bg-blue-500 text-white text-sm rounded-md"
            type="button">Unduh template</button>
          <button
            @click="importPlotting()"
            class="px-1 py-1 w-28 h-8 bg-green-500 text-white text-sm rounded-md"
            type="button">Lanjut</button>
        </div>
      </div>
    </div>
    <div
      v-else-if="plotting.mode === 'entry'"
      class="pl-8 pr-3 w-full h-full">
      <h1 class="text-sm text-white font-bold">Tambah Traffic</h1>
      <div class="py-3">
        <div class="flex flex-col flex-grow gap-1 w-full mb-1">
          <label class="text-xs text-white">Ping Time</label>
          <div class="flex-grow relative w-full h-8">
            <input
              v-model="plotting.indexed.ping_time"
              class="form-input w-full h-full rounded-md text-xs"
              type="text"
              placeholder="pilih ping time">
            <input
              @change="selectPingTime($event)"
              class="form-input absolute top-0 left-0 w-full h-8 rounded-md text-xs opacity-0 z-10"
              type="datetime-local">
            <i class="absolute right-3 py-1 h-full material-icons text-gray-500 text-lg">event</i>
          </div>
        </div>
        <div class="w-full mb-1">
          <label class="text-xs text-white">Latitude</label>
          <input
            v-model="plotting.indexed.latitude"
            class="w-full h-full rounded-md text-sm text-gray-500"
            type="text">
        </div>
        <div class="w-full mb-1">
          <label class="text-xs text-white">Longitude</label>
          <input
            v-model="plotting.indexed.longitude"
            class="w-full h-full rounded-md text-sm text-gray-500"
            type="text">
        </div>
        <div class="w-full mb-1">
          <label class="text-xs text-white">Speed</label>
          <input
            v-model="plotting.indexed.speed"
            class="w-full h-full rounded-md text-sm text-gray-500"
            type="text">
        </div>
        <div class="w-full mb-1">
          <label class="text-xs text-white">Pengaturan Plotting</label>
          <ul class="py-1">
            <li class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
              <input
                :checked="plotting.pointer"
                @change="togglePointer($event)"
                type="checkbox">
              <span class="text-xs text-slate-300">Input dengan mode klik</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="flex gap-1 justify-end items-center">
          <button
            @click="finishPlot()"
            class="px-1 py-1 grow-1 w-full h-8 bg-blue-500 text-white text-sm rounded-md"
            type="button">Selesai</button>
          <button
            @click="addPlot()"
            class="px-1 py-1 w-28 h-8 bg-green-500 text-white text-sm rounded-md"
            type="button">Lanjut</button>
        </div>
      </div>
    </div>
    <PopupMessage :message="message" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import libs from '../libs'
import { read, utils } from 'xlsx'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'MenuPlotting',
  data: () => ({
    file: null
  }),
  computed: {
    ...mapGetters([
      'message',
      'kapal',
      'plotting'
    ])
  },
  components: {
    PopupMessage
  },
  methods: {
    ...mapActions([
      'toInitPlotting',
      'toZoom',
      'toCopyPlot',
      'toChangeCursor'
    ]),
    ...mapMutations([
      'setPlottingMode',
      'setPlotting',
      'setPlottingPointer',
      'setPlottingPingtime',
      'setPlottingTo',
      'setMessage'
    ]),
    inputTransmitter: async function () {
      if (this.$route.path !== '/salmontrack/plotting') {
        this.$router.push({
          path: '/salmontrack/plotting',
          query : {
            transmitter: this.plotting.transmitter
          }
        })
      } else {
        this.toInitPlotting()
      }
    },
    downloadTemplate: function () {
      window.open(
        `${window.config.BASEURL}/document/template-traffic.xlsx`,
        '_blank'
      )
    },
    selectFile: function (e) {
      this.file = e.target.files[0]

      const reader = new FileReader()

      reader.onload = this.parsingFile

      reader.readAsArrayBuffer(this.file)
    },
    parsingFile: function (e) {
      const data = new Uint8Array(e.target.result)
      const workbook = read(data, {
        type: 'array',
        cellDates: true
      })

      let errorStatus = false
      let errorMessage = ''

      for (var sheetName in workbook.Sheets) {
        const sheet = workbook.Sheets[sheetName]
        let rowCount = false

        if (typeof sheet['!ref'] !== 'undefined') {
          rowCount = utils.decode_range(sheet['!ref']).e.r
        }

        if (rowCount === false || rowCount < 1) {
          errorStatus = true
          errorMessage = 'File tidak memiliki data!'
        } else if (typeof sheet['A1'] === 'undefined') {
          errorStatus = true
          errorMessage = 'File tidak memiliki kolom PING TIME !'
        } else if (typeof sheet['B1'] === 'undefined') {
          errorStatus = true
          errorMessage = 'File tidak memiliki kolom LATITUDE !'
        } else if (typeof sheet['C1'] === 'undefined') {
          errorStatus = true
          errorMessage = 'File tidak memiliki kolom LONGITUDE !'
        } else if (typeof sheet['D1'] === 'undefined') {
          errorStatus = true
          errorMessage = 'File tidak memiliki kolom SPEED !'
        } else {
          const histories = []

          for (var key = 1; key <= rowCount; key++) {
            const row = key + 1

            if (typeof sheet[`A${row}`] === 'undefined') {
              if (key === rowCount) break;

              errorStatus = true
              errorMessage = 'Kolom PING TIME pada baris ke-' + row + ' masih kosong!'
              break;
            } else if (typeof sheet[`B${row}`] === 'undefined') {
              if (key === rowCount) break;

              errorStatus = true
              errorMessage = 'Kolom LATITUDE pada baris ke-' + row + ' masih kosong!'
              break;
            } else if (typeof sheet[`C${row}`] === 'undefined') {
              if (key === rowCount) break;

              errorStatus = true
              errorMessage = 'Kolom LONGITUDE pada baris ke-' + row + ' masih kosong!'
              break;
            } else if (typeof sheet[`D${row}`] === 'undefined') {
              if (key === rowCount) break;

              errorStatus = true
              errorMessage = 'Kolom SPEED pada baris ke-' + row + ' masih kosong!'
              break;
            } else {
              const latitude = sheet[`B${row}`].v
              const longitude = sheet[`C${row}`].v
              let heading = 0

              if (key > 1) {
                const previousLatitude = sheet[`B${row - 1}`]
                const previousLongitude = sheet[`C${row - 1}`]

                if (previousLatitude && previousLongitude) {
                  heading = libs.angle(
                    [latitude, longitude],
                    [previousLatitude.v, previousLongitude.v]
                  )
                }
              } else {
                const nextLatitude = sheet[`B${row + 1}`]
                const nextLongitude = sheet[`C${row + 1}`]

                if (nextLatitude && nextLongitude) {
                  heading = libs.angle(
                    [nextLatitude.v, nextLongitude.v],
                    [latitude, longitude]
                  )
                }
              }

              const pingtime = libs.utcFormat(sheet[`A${row}`].v.toISOString(), 'object')

              histories.push({
                ping_time: pingtime.datetime,
                ping_timed: pingtime,
                latitude: latitude,
                longitude: longitude,
                speed: sheet[`D${row}`].v,
                heading: heading
              })
            }
          }

          this.setPlotting({
            transmitter: this.plotting.transmitter,
            features: histories
          })
        }
      }

      if (errorStatus) {
        this.setMessage({
          text: errorMessage,
          status: 400
        })
      } else {
        this.setPlottingTo(0)
        this.toZoom({
          view: [
            this.plotting.indexed.latitude,
            this.plotting.indexed.longitude
          ]
        })
      }
    },
    importPlotting: function () {
      this.toZoom({
        view: [
          this.plotting.indexed.latitude,
          this.plotting.indexed.longitude
        ]
      })
      this.setPlottingMode('entry')
    },
    selectPingTime: function (e) {
      const selectedPingTime = libs.utcFormat(e.target.value, 'object')

      this.setPlottingPingtime(selectedPingTime)
    },
    togglePointer: function (e) {
      if (e.target.checked) {
        this.setPlottingPointer(true)
        this.toChangeCursor('crosshair')
      } else {
        this.setPlottingPointer(false)
        this.toChangeCursor('grab')
      }
    },
    addPlot: function () {
      if (this.plotting.index === this.plotting.lastIndex) {
        this.toCopyPlot({})
      } else {
        this.setPlottingTo(this.plotting.index + 1)
      }

      this.toZoom({
        view: [
          this.plotting.indexed.latitude,
          this.plotting.indexed.longitude
        ]
      })
    },
    finishPlot: async function () {
      const pingtime = []
      const latitude = []
      const longitude = []
      const speed = []
      const heading = []

      for (var history of this.histories.features) {
        pingtime.push(history.PING_TIME_TIMES)
        latitude.push(history.LATITUDE)
        longitude.push(history.LONGITUDE)
        speed.push(history.SPEED)
        heading.push(history.HEADING)
      }

      const traffic = {
        'nomor_buku_kapal': this.kapal.nomor_buku_kapal,
        'transmitter': this.kapal.transmitter,
        'ping_time': pingtime,
        'latitude': latitude,
        'longitude': longitude,
        'speed': speed,
        'heading': heading
      }

      await this.toAddTraffic(traffic)
    }
  }
}
</script>
